<template>
  <VueFinalModal
    :esc-to-close="true"
    class="flex justify-center items-center"
    content-class="relative flex flex-col w-[600px] mx-auto bg-white border rounded-lg"
  >
    <div>
      <h2 class="text-center">Details of this version</h2>
      <div id="tabs" class="p-6 rounded-md ">
        <div class="tabs">
            <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Changes</a>
            <a v-on:click="activetab=2" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Original</a>
        </div>

        <div class="p-8 rounded-md max-h-2/3" >
            <div v-show="activetab === 1" class="w-full max-h-96 overflow-scroll">
              <table>
                <thead>
                  <tr>
                    <th>Field Name</th>
                    <th>Original Value</th>
                    <th>Changed To</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, field) in data.changes" :key="field">
                    <td>{{ field }}:</td>
                    <td>{{ item.before }}</td>
                    <td>{{ item.after }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-show="activetab === 2" class="w-full h-full max-h-96 overflow-scroll">
              <table>
                <thead>
                  <tr>
                    <th>Field Name</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, field) in data.original" :key="field">
                    <td>{{ field }}:</td>
                    <td>{{ item }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
        </div>
        <a class="btn btn-secondary float-left" v-bind:href="relatedChangesLink"> View related Changes</a>
        <button class="btn btn-secondary float-right" @click="closeModal()">Close</button>
        <div class="h-10">&nbsp;</div>
    
      </div>
    </div>
  </VueFinalModal>
</template>

<script setup>
  import { onMounted, ref, computed } from 'vue'
  import { VueFinalModal } from 'vue-final-modal'

  const props = defineProps({
    params: Object,
  })

  const emit = defineEmits(['close'])

  let data = ref({})
  let activetab = ref(1)

  onMounted(() => {
    data.value = props.params.data
  })

  const relatedChangesLink = computed(() => {
    return "/changes?correlation_uuid=" + data.value.correlation_uuid
  })

  function closeModal () {
    emit('close')
  }
</script>

<style>
  .vm--modal {
    overflow:hidden;
  }
  .info {
    padding: 10px;
    display: flex;
    flex-direction: row;
  }
  .bold {
    font-weight: bold;
  }
  .value {
    padding-left: 5px;
  }
.tabs {
    overflow: hidden;
    margin-left: 20px;
    margin-bottom: -2px;
}

.tabs ul {
    list-style-type: none;
    margin-left: 20px;
}

.tabs a{
    float: left;
    cursor: pointer;
    padding: 12px 24px;
    transition: background-color 0.2s;
    border: 1px solid #ccc;
    border-right: none;
    background-color: #f1f1f1;
    border-radius: 10px 10px 0 0;
    font-weight: bold;
}
.tabs a:last-child { 
    border-right: 1px solid #ccc;
}

/* Change background color of tabs on hover */
.tabs a:hover {
    background-color: #aaa;
    color: #fff;
}

/* Styling for active tab */
.tabs a.active {
    background-color: #fff;
    color: #484848;
    border-bottom: 2px solid #fff;
    cursor: default;
}

/* Style the tab content */
.tabcontent {
    padding: 30px;
    border: 1px solid #ccc;
    border-radius: 10px;
    box-shadow: 3px 3px 6px #e1e1e1;
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

</style>
